import { state } from '../map_state/state'
import { Renderer } from '../renderer'
import { callMethodOnKeydown, isTyping } from '../helpers'
import { loader } from '../map_state/loader'
import { cropTool } from './crop_tool'
import { historyTool } from './history_tool'

class RotateTool {
  constructor () {
    this.r_left = document.getElementById('mct-rotate-left')
    this.r_right = document.getElementById('mct-rotate-right')
    this.toggleVisibility()
    this.bindEvents()
  }

  bindEvents () {
    this.onKeyDown = this.onKeyDown.bind(this)
    this.rotateLeft = this.rotateLeft.bind(this)
    this.rotateRight = this.rotateRight.bind(this)
    this.r_left.addEventListener('click', this.rotateLeft)
    this.r_right.addEventListener('click', this.rotateRight)
    document.addEventListener('keydown', this.onKeyDown)
  }

  unBindEvents () {
    this.r_left.removeEventListener('click', this.rotateLeft)
    this.r_right.removeEventListener('click', this.rotateRight)
    document.removeEventListener('keydown', this.onKeyDown)
  }

  onKeyDown (e) {
    if (isTyping(e.target)) return
    if (e.key === 'q' && !this.r_left.classList.contains('hidden')) callMethodOnKeydown(e.target, this.rotateLeft)
    if (e.key === 'w' && !this.r_right.classList.contains('hidden')) callMethodOnKeydown(e.target, this.rotateRight)
  }

  rotateLeft = () => this.rotate90('left')
  rotateRight = () => this.rotate90('right')

  rotate90 = async (dir) => {
    if (!state.mapImage || !state.canEditMap) return

    if (state.cropMode) cropTool.activate(false)
    loader.setStatusMessage('processing', 'Rotating map...')
    const iw = state.mapImage.naturalWidth
    const ih = state.mapImage.naturalHeight

    const cx = state.mapWorld.x + iw / 2
    const cy = state.mapWorld.y + ih / 2

    const off = document.createElement('canvas')
    off.width = ih
    off.height = iw
    const ctx = off.getContext('2d')

    ctx.save()
    if (dir === 'right') {
      ctx.translate(ih, 0)
      ctx.rotate(Math.PI / 2)
    } else {
      ctx.translate(0, iw)
      ctx.rotate(-Math.PI / 2)
    }
    ctx.drawImage(state.mapImage, 0, 0)
    ctx.restore()

    const dataUrl = off.toDataURL('image/png')
    const newImg = new Image()

    await new Promise((resolve, reject) => {
      newImg.onload = resolve
      newImg.onerror = reject
      newImg.src = dataUrl
    })

    state.mapImage = newImg

    const nw = newImg.naturalWidth
    const nh = newImg.naturalHeight

    state.mapWorld = { x: cx - nw / 2, y: cy - nh / 2 }

    historyTool.add()
    Renderer.render()
  }

  toggleVisibility () {
    this.r_left.classList.toggle('hidden', !state.mapImage || !state.canEditMap)
    this.r_right.classList.toggle('hidden', !state.mapImage || !state.canEditMap)
  }
}

export let rotateTool = null

export function initRotateTool () {
  rotateTool = new RotateTool()
  return rotateTool
}
